module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatDisorder/Kanagawa_HeatDisorder_HadGEM2_RCP85_Now.png";